import {
  waitForContextToBeReady
} from "./chunk-E7LBAH63.mjs";
import {
  sendEvents
} from "./chunk-56HYCTGH.mjs";
import {
  mergeAnalyticsContexts
} from "./chunk-J5XGMHOG.mjs";

// src/contexts/update-current-context/update-current-context.ts
async function updateCurrentContext(values) {
  if (window.yvaDatastore && window.yvaDatastore.currentContextId) {
    const contextIsReady = await waitForContextToBeReady();
    let newContextId = self.crypto.randomUUID();
    let currentContext = window.yvaDatastore.contexts[window.yvaDatastore.currentContextId];
    if (contextIsReady && currentContext && currentContext.status === "ready") {
      window.yvaDatastore.contexts[newContextId] = {
        data: { device: {} },
        status: "initialized"
      };
      window.yvaDatastore.currentContextId = newContextId;
      const newContextData = mergeAnalyticsContexts(
        currentContext.data,
        /**
         * Intentionally overloading the source of values because some pieces of the context may require an async call to get the value. This is similar to `initializeContext` except in this case we're merging objects.
         */
        typeof values === "function" ? await values() : values
      );
      window.yvaDatastore.contexts[newContextId] = { data: newContextData, status: "ready" };
    }
  }
  sendEvents();
}

export {
  updateCurrentContext
};
